import { decryptText } from "../utilservices";

export const fetchChildProducers = async (pageNumber = 1, pageSize = 3, filtrarPor = "", textoBusqueda = "", childId:number | null) => {

  const token = JSON.parse(decryptText(sessionStorage.getItem('data') || '{}')).token || null
  const baseUrlenv = process.env.REACT_APP_API_URL;
  // Obtener seasonId directamente de los filtros almacenados
  const savedFilters = JSON.parse(decryptText(sessionStorage.getItem('filters') || '{}'));
  const idseason = savedFilters.seasonId || 6; // Usar 6 como fallback
  //const url = `${baseUrlenv}Productor`;
  let url = `${baseUrlenv}Productor/${pageNumber}/${pageSize}/productorPadreId/${childId}/${idseason}`;
  
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Error en la llamada al API");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
